import { Component, OnDestroy} from '@angular/core';
import { ActivatedRoute, Params, ParamMap } from "@angular/router";
import { ContractModelService } from '../contracts.model.service';
import { NavigationStateService } from '../../navigation/navigation.state.service';
import { ActDialogStateService } from '../act-dialog/act.dialog.contracts.state.service';
import { CreateDialogContractStateService } from '../create-quest/create.dialog.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { environment } from '../../../../../environments/environment';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.single.index.component.html',
  providers: []
})

export class ContractsSingleIndexComponent implements OnDestroy  {

  model: any = {};
  errorMessage: string;
  mobileInfoBoxStatus: boolean = false;
  settings: any = {};

  constructor(
    private route: ActivatedRoute,
    private contractModelService: ContractModelService,
    private navigationStateService: NavigationStateService,
    private actDialogStateService: ActDialogStateService,
    private authUtil: AuthUtil,
    private createDialogContractStateService: CreateDialogContractStateService,) {
      this.settings = environment;
  }

  ngOnInit() {
    this.navigationStateService.triggerNavigationStatus({status: false});
    let data = this.route.snapshot.data['data'];

    if(this.authUtil.isError(data.json())) {
          this.authUtil.checkErrorResponse(data.json());
          this.contractModelService.setData(false);
    } else {


      this.model = data.json().response;
      if (!this.model['annualRent']) {
          this.model['annualRent'] = '0';
      }

      if(this.model['arrears']) {
          if(this.model.arrears['arrearsRentAmount']) {
            if(this.model.arrears.arrearsRentAmount > 0) {
              this.model['formatPriceAp'] = this.model.arrears.arrearsRentAmount;
            } else {
              this.model['formatPriceAp'] = String(this.model.arrears.arrearsRentAmount).replace('-', '');
            }
          }
          if(this.model.arrears['arrearsFinesAmount']) {
            if(this.model.arrears.arrearsFinesAmount > 0) {
              this.model['formatPricePen'] = this.model.arrears.arrearsFinesAmount;
            } else {
              this.model['formatPricePen'] = String(this.model.arrears.arrearsFinesAmount).replace('-', '');
            }
          }
      }
      this.contractModelService.setData(this.model);
    }
  }

  openActDialog($event) {
    $event.preventDefault();
    this.actDialogStateService.triggerDialogStatus({display: true})
  }

  openChatDialog($event) {
    $event.preventDefault();
    this.createDialogContractStateService.triggerDialogStatus({display: true})
  }

  toggleMobileInfoBox($event) {
    $event.preventDefault();
    this.mobileInfoBoxStatus = !this.mobileInfoBoxStatus;
  }

  ngOnDestroy() {
    this.navigationStateService.triggerNavigationStatus({status: true});
    this.contractModelService.removeData();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/single-index/contracts.single.index.component.ts